import Cookies from 'js-cookie';

export const setValue = (key, value) => Cookies.set(key, value);

export const setValueWithExpire = (key, value, expire) => Cookies.set(key, value, expire);

export const getValue = key => Cookies.get(key);

export const removeKey = key => Cookies.remove(key);
